<div *ngIf="!preCandidatos || preCandidatos.length === 0" class="row d-flex text-center align-items-center mt-5 mb-5">
  <div class="col-md-12">
    <h5>Não existem candidaturas deferidas</h5>
  </div>
</div>

<div class="px-2 pt-3">

  <p-table #candidatosList [columns]="cols" [value]="preCandidatos" dataKey="nome" [responsive]="true"
    class="p-datatable-resposive">

    <!--Corpo da Tabela-->
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
      <tr [pSelectableRow]="rowData">
        <td class="custom-td" *ngFor="let col of columns; let last = last">
          <div class="d-flex justify-content-between align-items-center">
            {{rowData[col.field]}}
            <a href="#" [pRowToggler]="rowData" pTooltip="Currículo" class="btn btn-outline-info">
              <i class="fas fa-search-plus"></i>
            </a>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- Template de Curriculum-->
    <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
      <tr>
        <td [attr.colspan]="columns.length + 2">
          <div class="ui-g ui-fluid" style="font-size:16px;padding:20px">

            <!-- Parte da imagem -->
            <div class="ui-g-12 ui-md-3" style="text-align:center">
              <img *ngIf="rowData?.imagem" [attr.alt]="rowData.urlImagem" src="{{rowData?.imagem}}" class="img-fluid"
                alt="Responsive image">
              <img *ngIf="!rowData?.imagem" [attr.alt]="rowData.urlImagem" [src]="'/assets/img/avatar-sem-imagem.png'"
                class="img-fluid" alt="Responsive image">
            </div>

            <!-- Parte das informações -->
            <div class="ui-g-12 ui-md-9">
              <div class="ui-g">
                <div class="ui-g-12 text-justify">
                  <h4 class="text-dark mb-3" *ngIf="rowData?.nome !=null ">{{rowData?.nome}} </h4>
                  <h6 class="text-dark mb-3" *ngIf="rowData?.cpf !=null "><b>CPF:</b> {{rowData?.cpf}} </h6>
                  <h6 class="text-dark mb-3" *ngIf="rowData?.email !=null "><b>E-mail:</b> {{rowData?.email}} </h6>
                  <div>
                    <h6 class="text-dark mb-3" *ngIf="rowData?.curriculum !=null "><b>Currículo:</b> </h6>
                    <div [innerHtml]="rowData?.curriculum" class="text-justify"></div>
                  </div><br>
                  <div>
                    <h6 class="text-dark mb-3"><b>Sua Análise:</b> </h6>
                    <div [innerHtml]="rowData?.statusAnaliseAprovador" class="text-justify"></div>
                  </div><br>
                  <div>
                    <h6 class="text-dark mb-3"><b>Observações:</b> </h6>
                    <div [innerHtml]="rowData?.observacao" class="text-justify"></div>
                  </div><br>
                  <div *ngIf="rowData?.statusAnaliseAprovador == 'INDEFERIDA'"> 
                    <h6 class="text-dark mb-3"><b>Justificativa do indeferimento:</b> </h6>
                    <div [innerHtml]="rowData?.justificativaIndeferimento" class="text-justify"></div>
                  </div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <div class="d-flex justify-content-center mt-3">
                    <button type="button" class="btn btn-success p-2 mr-2" style="width: 270px; border: 1px solid;"
                      (click)="showModalAlterarLocal(rowData?.id)"> Alterar </button>
                  </div>
                  <!-- Modal Alterar -->
                  <div *ngIf="displayModalAlterar">
                    <p-dialog header="Confirmar Alteração" [(visible)]="displayModalAlterar" [modal]="true"
                      [style]="{width: '50vw', 'border': '10px'}" [draggable]="false" [resizable]="false"
                      aria-hidden="true">

                      <ng-template pTemplate="footer">
                      </ng-template>

                      <div class="d-flex justify-content-end">
                        <button type="button" class="btn btn-success p-2 mr-2" style="width: 270px; border: 1px solid;"
                          (click)="showModalDeferirLocal(rowData?.id)"> Deferir </button>
                        <button type="button" class="btn btn-danger p-2" style="width: 270px; border: 1px solid;"
                          (click)="showModalIndeferirLocal()"> Indeferir </button>
                      </div>
                    </p-dialog>
                  </div>

                  <!-- Modal Deferir -->
                  <div *ngIf="displayModalDeferir">
                    <p-dialog header="Confirmar deferimento" [(visible)]="displayModalDeferir" [modal]="true"
                      [style]="{width: '50vw', 'border': '10px'}" [draggable]="false" [resizable]="false"
                      aria-hidden="true">

                      <div class="p-fluid">
                        <div class="p-field">
                          <label for="observacao" style="display: block;"><b>Observações: </b></label>
                          <textarea id="observacao" placeholder="Digite suas observações..." pInputTextarea
                            [(ngModel)]="observacao" rows="5" style="width: 100%;"></textarea>
                        </div>
                      </div>

                      <ng-template pTemplate="footer">
                      </ng-template>

                      <div class="d-flex justify-content-end">
                        <button type="button" class="btn btn-success btn-block p-2" style="color: white; width: 20%;"
                          (click)="alterarDeferir(observacao, rowData?.id)"> Confirmar </button>
                      </div>
                    </p-dialog>
                  </div>

                  <!-- Modal Indeferir -->
                  <div *ngIf="displayModalIndeferir">
                    <p-dialog header="Confirmar indeferimento" [(visible)]="displayModalIndeferir" [modal]="true"
                      [style]="{width: '50vw', 'border': '10px'}" [draggable]="false" [resizable]="false">

                      <div class="p-fluid">
                        <div class="p-field">
                          <label for="observacao" style="display: block;"><b>Observações: </b></label>
                          <textarea id="observacao" placeholder="Digite suas observações..." pInputTextarea
                            [(ngModel)]="observacao" rows="5" style="width: 100%;"></textarea>
                        </div>
                      </div>

                      <div class="p-fluid" *ngIf="showJustificativa">
                        <div class="p-field">
                          <label for="justificativaIndeferimento" style="display: block;"><b>Justificativa do
                              Indeferimento:* </b></label>
                          <textarea id="justificativaIndeferimento" placeholder="Digite sua justificativa..."
                            pInputTextarea [(ngModel)]="justificativaIndeferimento" rows="5"
                            style="width: 100%;"></textarea>
                        </div>
                      </div>

                      <ng-template pTemplate="footer">
                        <button type="button" (click)="hideModalIndeferirLocal()">Fechar</button>
                      </ng-template>

                      <div class="d-flex justify-content-end">
                        <button type="button" class="btn btn-success btn-block p-2" style="color: white; width: 20%;"
                          (click)="alterarIndeferir(observacao, justificativaIndeferimento, rowData?.id)"> Confirmar </button>
                      </div>
                    </p-dialog>
                  </div>